import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$workspaceId/financeiro/lancamentos')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/w/$workspaceId/financeiro/contas-receber', params });
  },
});
